export const addDescriptionToImageAttribute = () => {
  jQuery("body").on("yith_wccl_form_initialized", function () {
    document
      .querySelectorAll("form.variations_form select")
      .forEach((select) => {
        const attributes = Array.from(
          new Set([
            ...Array.from(
              document.querySelectorAll("form.variations_form select")
            ).map((s) => s.id),
          ])
        ).filter((attr) => attr !== "pa_couleur");

        if (attributes.includes(select.id)) {
          const closestTd = select.closest("td");

          if (closestTd) {
            closestTd
              .querySelectorAll(".select_option_image")
              .forEach((selectOption) => {
                const label = selectOption.getAttribute("data-label");

                if (label) {
                  const wrapper = selectOption.querySelector(
                    ".yith_wccl_value_wrapper"
                  );

                  if (wrapper && !wrapper.querySelector(".image-label")) {
                    // Prevent multiple additions
                    const span = document.createElement("span");
                    span.classList.add("image-label");
                    span.textContent = label;
                    wrapper.appendChild(span);
                  }
                }
              });
          } else {
            console.warn(`No closest <td> found for select#${select.id}`);
          }
        }
      });
  });
};
